import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import React from 'react';

// One description of each platform, shared by the list and both dialogs, so
// the colour, label and what Meta allows are never stated twice.
export const PLATFORM_META = {
  facebook: {
    key: 'facebook',
    label: 'Facebook',
    color: '#1877F2',
    icon: <FacebookIcon sx={{ color: '#1877F2' }} />,
    // A Page video's description can be edited after publishing.
    canEditCaption: true,
  },
  instagram: {
    key: 'instagram',
    label: 'Instagram',
    color: '#E1306C',
    icon: <InstagramIcon sx={{ color: '#E1306C' }} />,
    // Meta exposes no endpoint for editing a published caption.
    canEditCaption: false,
  },
};

// Colours match the MUI Chip palette used elsewhere in the dashboard.
export const STATUS_COLOR = {
  published: 'success',
  failed: 'error',
  deleted: 'default',
};

export const formatDate = (value) => {
  if (!value) return '-';
  const d = new Date(value);
  return `${d.toLocaleDateString()} ${d.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
};
